<template>
    <nav class="navbar navbar-expand-md navbar-dark bg-primary shadow-sm">
        <div class="container">
            <router-link class="navbar-brand" :to="{name:'home'}" >
                We Don't Buy Crime
            </router-link>
            
            <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
            </button>

            <div class="collapse navbar-collapse" id="navbarSupportedContent">
                <!-- Left Side Of Navbar -->
                <ul class="navbar-nav mr-auto" >
                    <template v-if="loggedIn && !currentUser.awaiting_authorisation">
    
                    <li class="nav-item">
                        <router-link class="nav-link" :to="{name:'retailers.index'}">Retailers</router-link>
                    </li>
                    <li class="nav-item">
                        <router-link class="nav-link" :to="{name:'search.index'}">Search</router-link>
                    </li>
                    <li class="nav-item dropdown" v-if="currentUser.can('super-user')">
                        <a id="navbarAdminDropdown" class="nav-link dropdown-toggle" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" v-pre>
                            Admin
                        </a>

                        <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdown">
                            <router-link class="dropdown-item" :to="{name:'lpas.index'}">LPAs</router-link>
                            <router-link class="dropdown-item" :to="{name:'neighbourhoods.index'}">Neighbourhoods</router-link>
                            <router-link class="dropdown-item" :to="{name:'emailTemplate.edit'}">Email Template</router-link>
                            <router-link class="dropdown-item" :to="{name:'users.index'}">Users</router-link>
                            <template v-if="currentUser.can('admin')">
                                <div class="dropdown-divider"></div>
                                <router-link class="dropdown-item" :to="{name:'productCategories.index'}">Product Categories</router-link>
                                <router-link class="dropdown-item" :to="{name:'visitFrequency.edit'}">Visit Frequency</router-link>
                                <router-link class="dropdown-item" :to="{name:'forces.index'}">Forces</router-link>
                                <router-link class="dropdown-item" :to="{name:'ranks.index'}">Ranks</router-link>
                            </template>
                        </div>
                    </li>

                    </template>
                </ul>

                <!-- Right Side Of Navbar -->
                <ul class="navbar-nav ml-auto">
                    <!-- Authentication Links -->
                    <template v-if="! loggedIn">
                    <!-- @guest -->
                        <li class="nav-item">
                            <router-link class="nav-link" :to="{name:'login'}">Login</router-link>
                        </li>
                        
                        <li class="nav-item">
                            <router-link class="nav-link" :to="{name:'register'}">Register</router-link>
                        </li>
                        
                    </template>
                    <template v-else>

                        <li class="nav-item dropdown">
                            <a id="navbarDropdown" class="nav-link dropdown-toggle" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                {{ currentUser.name }}
                            </a>

                            <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdown">
                                <router-link class="dropdown-item" :to="{name:'profile', params: {id:currentUser.id}}" v-if="!currentUser.awaiting_authorisation">Profile</router-link>
                                <a class="dropdown-item" href="#" @click.prevent="logout">  
                                    Logout
                                </a>
                            </div>
                        </li>

                    </template>

                </ul>
            </div>
        </div>
    </nav>
</template>

<script>
import {mapState} from "vuex";
import CurrentUser from "../../mixins/CurrentUser";
import AuthService from "../../services/AuthService";

export default {
    data: function () {
        return {
        }
    },

    mixins: [CurrentUser],

    methods: {
        logout: function () {
            AuthService.logout()
                .then( () => { 
                    this.$store.commit('logout');
                    
                    if (this.$router.history.current.name != 'home') {
                        this.$router.push({name:'home'})
                    }
                })
                .catch( function ( {response} ) {
                    response;
                });
        },
    },
    computed: {
        ...mapState(['loggedIn']),
    },
}
</script>
